import { ButtonWrapper } from "./styles";
import { Icon } from "../../components";
import { IconButtonProps } from "./types";
import { Theme } from "../../styles";
import { useTheme } from "styled-components";

const IconButton = ({
  iconName,
  width,
  height,
  fill,
  className,
  onClick,
  children,
  isFullRounded,
  isDisabled,
  variant = "outlined"
}: IconButtonProps) => {
  const { colors } = useTheme() as Theme;

  return (
    <ButtonWrapper
      onClick={onClick}
      isFullRounded={isFullRounded}
      hasChildren={!!children}
      disabled={isDisabled}
      variant={variant}>
      <Icon
        iconName={iconName}
        width={width}
        height={height}
        fill={isDisabled ? colors.disabled : fill}
        className={className}
      />
      {children}
    </ButtonWrapper>
  );
};
export default IconButton;
